import { z } from 'zod/v4';
export const fdaAdverseEventsSearchInputSchema = z.object({
    device_name: z.string().optional(),
    brand_name: z.string().optional(),
    manufacturer_name: z.string().optional(),
    start_date: z.string().optional(),
    end_date: z.string().optional(),
    event_type: z.enum(['Malfunction', 'Injury', 'Death']).optional(),
    product_code: z.string().optional(),
    device_class: z.enum(['1', '2', '3']).optional(),
    limit: z.number().min(1).max(1000).default(1000),
    search_type: z.enum(['records', 'count']).default('records'),
    count_field: z
        .enum([
        'event_type.exact',
        'device.generic_name.exact',
        'manufacturer_name.exact',
        'device.device_class.exact',
    ])
        .default('event_type.exact'),
});
export const fdaAdverseEventDeviceSchema = z.object({
    generic_name: z.string().optional(),
    brand_name: z.string().optional(),
    device_class: z.string().optional(),
    device_name: z.string().optional(),
    medical_specialty_description: z.string().optional(),
    regulation_number: z.string().optional(),
    product_code: z.string().optional(),
    manufacturer_name: z.string().optional(),
});
export const fdaAdverseEventSchema = z.object({
    report_number: z.string().optional(),
    date_received: z.string().optional(),
    date_of_event: z.string().optional(),
    event_type: z.array(z.string()).optional(),
    product_problems: z.array(z.string()).optional(),
    device: fdaAdverseEventDeviceSchema.optional(),
    remedial_action: z.array(z.string()).optional(),
    adverse_event_flag: z.string().optional(),
    report_source_code: z.string().optional(),
    manufacturer_name: z.string().optional(),
    patient_problems: z.array(z.string()).optional(),
    narratives: z.array(z.string()).optional(),
    mdr_report_key: z.string().optional(),
});
export const fdaAdverseEventsSearchOutputSchema = z.object({
    meta: z
        .object({
        total: z.number().optional(),
        limit: z.number().optional(),
        skip: z.number().optional(),
    })
        .optional(),
    results: z.array(fdaAdverseEventSchema).optional(),
    count_results: z
        .array(z.object({
        term: z.string(),
        count: z.number(),
    }))
        .optional(),
    search_query_built: z.string(),
    search_criteria: z.object({
        device_name: z.string().optional(),
        manufacturer_name: z.string().optional(),
        brand_name: z.string().optional(),
        start_date: z.string().optional(),
        end_date: z.string().optional(),
        event_type: z.string().optional(),
        product_code: z.string().optional(),
        device_class: z.string().optional(),
    }),
    api_url: z.string(),
});
//# sourceMappingURL=fda-adverse-events-search.js.map